import IDMUtils from '../../IDMUtils';
import APIRequest from '../APIRequest';
//
export default class APIUserPartitionFile {
  constructor(API) {
    this.api = API;
  }
  /* File operations */
  async getDownloadURL(userID, partID, fileID) {
    const signedURLResp = await this._getSignURL(userID, partID, fileID);
    if (signedURLResp.statusCode != 200 || !signedURLResp.body.fileURL) return signedURLResp;
    return signedURLResp.body.fileURL;
  }
  async download(userID, partID, fileID) {
    const signedURLResp = await this.getDownloadURL(userID, partID, fileID);
    if (signedURLResp.statusCode && signedURLResp.statusCode != 200) return signedURLResp;
    return this._getRemoteFile(signedURLResp);
  }
  async delete(userID, partID, fileID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/user/${userID}/partFile/${partID}/${fileID}`;
    return await req.exec();
  }
  async upload(userID, partID, file, fileID) {
    const signedURLResp = await this._getSignURL(userID, partID, fileID, file.type);
    if (signedURLResp.statusCode != 200 || !signedURLResp.body.fileURL) return signedURLResp;
    const signedURL = signedURLResp.body.fileURL;
    const uploadResp = await this._uploadRemoteFile(file, signedURL);
    return uploadResp;
  }

  // Private file operations
  async _uploadRemoteFile(file, url) {
    const req = new APIRequest('PUT');
    req.baseURL = url;
    req.appendHeader('Content-type', file.type);
    req.appendHeader('Content-length', file.file.length);
    req.body = IDMUtils.dataURItoBlob(file.file);
    req.bodyType = 'BINARY';
    return await req.exec();
  }
  async _getSignURL(userID, partID, fileID, fileType) {
    const req = await this.api.newBaseRequest(fileType ? 'POST' : 'GET');
    req.path = `/user/${userID}/partFile/${partID}/${fileID}`;
    if (fileType) req.appendQueryParam('fileType', fileType);
    return await req.exec();
  }
  async _getRemoteFile(url) {
    const request = new APIRequest('GET');
    request.baseURL = url;
    request.bodyType = 'BINARY';
    return await request.exec();
  }
}
